/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { RecentlyVisited } from '../models/recently-visited';
import { recentlyVisitedDelete } from '../fn/recently-visited/recently-visited-delete';
import { RecentlyVisitedDelete$Params } from '../fn/recently-visited/recently-visited-delete';
import { recentlyVisitedGetRecentlyVisitedPatientRecords } from '../fn/recently-visited/recently-visited-get-recently-visited-patient-records';
import { RecentlyVisitedGetRecentlyVisitedPatientRecords$Params } from '../fn/recently-visited/recently-visited-get-recently-visited-patient-records';
import { recentlyVisitedPost } from '../fn/recently-visited/recently-visited-post';
import { RecentlyVisitedPost$Params } from '../fn/recently-visited/recently-visited-post';

@Injectable({ providedIn: 'root' })
export class RecentlyVisitedService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `recentlyVisitedGetRecentlyVisitedPatientRecords()` */
  static readonly RecentlyVisitedGetRecentlyVisitedPatientRecordsPath = '/getRecentlyVisitedPatientRecords';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recentlyVisitedGetRecentlyVisitedPatientRecords()` instead.
   *
   * This method doesn't expect any request body.
   */
  recentlyVisitedGetRecentlyVisitedPatientRecords$Response(params?: RecentlyVisitedGetRecentlyVisitedPatientRecords$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RecentlyVisited>>> {
    return recentlyVisitedGetRecentlyVisitedPatientRecords(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recentlyVisitedGetRecentlyVisitedPatientRecords$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recentlyVisitedGetRecentlyVisitedPatientRecords(params?: RecentlyVisitedGetRecentlyVisitedPatientRecords$Params, context?: HttpContext): Observable<Array<RecentlyVisited>> {
    return this.recentlyVisitedGetRecentlyVisitedPatientRecords$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RecentlyVisited>>): Array<RecentlyVisited> => r.body)
    );
  }

  /** Path part for operation `recentlyVisitedPost()` */
  static readonly RecentlyVisitedPostPath = '/addRecentlyVisitedPatientRecords';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recentlyVisitedPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  recentlyVisitedPost$Response(params?: RecentlyVisitedPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return recentlyVisitedPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recentlyVisitedPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recentlyVisitedPost(params?: RecentlyVisitedPost$Params, context?: HttpContext): Observable<Blob> {
    return this.recentlyVisitedPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `recentlyVisitedDelete()` */
  static readonly RecentlyVisitedDeletePath = '/deleteVisitedByUser/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recentlyVisitedDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  recentlyVisitedDelete$Response(params: RecentlyVisitedDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return recentlyVisitedDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recentlyVisitedDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  recentlyVisitedDelete(params: RecentlyVisitedDelete$Params, context?: HttpContext): Observable<Blob> {
    return this.recentlyVisitedDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
